/**
 * Created by lixinwei on 17/4/19.
 */

import * as types from './types'

const mutations = {
    [types.SHOW_LOADING](state) {
        state.ajax_loding = true;
    },

    [types.HIDE_LOADING](state) {
        state.ajax_loading = false;
    }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js